import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createStaticVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Nitro.svg?component
var Nitro_exports = /* @__PURE__ */ __exportAll({
	default: () => Nitro_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createStaticVNode("<path fill=\"url(#a)\" fill-rule=\"evenodd\" d=\"M19.608 5.51C16.023 1.308 9.712.808 5.51 4.392 1.308 7.977.808 14.288 4.392 18.49c3.585 4.202 9.896 4.702 14.098 1.118 4.202-3.585 4.702-9.896 1.118-14.098m-4.982 5.249c.385 0 .631.417.438.75l-.056.096-3.774 6.21a.39.39 0 0 1-.33.185h-.36a.378.378 0 0 1-.366-.472l1.024-3.959a.5.5 0 0 0-.484-.625H9.145a.5.5 0 0 1-.484-.625l1.545-5.978a.46.46 0 0 1 .448-.34l.067.001h1.584a.5.5 0 0 1 .496.568l-.01.071-.604 3.533a.5.5 0 0 0 .493.585z\" clip-rule=\"evenodd\"></path><defs><radialGradient id=\"a\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"matrix(19.5 0 0 198.851 4 12)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#31B2F3\"></stop><stop offset=\".474\" stop-color=\"#F27CEC\"></stop><stop offset=\"1\" stop-color=\"#FD6641\"></stop></radialGradient></defs>", 2)])]);
}
var Nitro_default = { render: render$1 };
//#endregion
export { Nitro_exports, Nitro_default as default, render$1 as render };

//# sourceMappingURL=Nitro.svg_component.js.map